import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Library from "./pages/Library";
import Editor from "./pages/Editor";
import PaymentSuccess, { PaymentCancel } from "./pages/Payment";
import PayInvoice from "./pages/PayInvoice";
import Admin from "./pages/Admin";
import { OfflineBadge } from "./components/OfflineBadge";
import { ActivationNotice } from "./components/ActivationNotice";
import { initTheme } from "./components/ThemeToggle";

initTheme();

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Library />} />
        <Route path="/doc/:id" element={<Editor />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/paypal" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/pay/:id" element={<PayInvoice />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <OfflineBadge />
      <ActivationNotice />
      <Toaster position="bottom-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
